'use client';

import { __styles, mergeClasses } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
export const swatchPickerClassNames = {
  root: 'fui-SwatchPicker'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f14ufcw5",
    mc9l5x: "f22iagw"
  },
  row: {
    Beiy3e4: "f1063pyq"
  },
  grid: {
    Beiy3e4: "f1vx9l62"
  },
  spacingSmall: {
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "f1t6b6ee"
  },
  spacingMedium: {
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "f4xv25i"
  }
}, {
  d: [[".f14ufcw5{padding:var(--spacingHorizontalNone) var(--spacingVerticalNone);}", {
    p: -1
  }], ".f22iagw{display:flex;}", ".f1063pyq{flex-direction:row;}", ".f1vx9l62{flex-direction:column;}", [".f1t6b6ee{gap:2px;}", {
    p: -1
  }], [".f4xv25i{gap:4px;}", {
    p: -1
  }]]
});
/**
 * Apply styling to the SwatchPicker slots based on the state
 */
export const useSwatchPickerStyles_unstable = state => {
  const styles = useStyles();
  const layoutStyle = state.isGrid ? styles.grid : styles.row;
  const spacingStyle = state.spacing === 'small' ? styles.spacingSmall : styles.spacingMedium;
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(swatchPickerClassNames.root, styles.root, layoutStyle, spacingStyle, state.root.className);
  return state;
};